import gql from 'graphql-tag';
import { evaluationFieldsFragment } from './evaluationFieldsFragment';
import { questionFieldsFragment } from './questionFieldsFragment';
import { sanityDocumentFieldsFragment } from './sanityDocumentFieldsFragment';
import { scheduledSessionParticipantCorrectionEntryFieldsFragment } from './scheduledSessionParticipantCorrectionEntryFieldsFragment';

export const scheduledSessionParticipantCorrectionFieldsFragment = gql`
  fragment ScheduledSessionParticipantCorrectionFields on ScheduledSessionParticipantCorrection {
    ... on SanityDocument {
      ...AdminSanityDocumentFields
    }
    participant { _ref }
    scheduledSession { _ref }
    comment
    corrections {
      ...AdminScheduledSessionParticipantCorrectionEntryFields
    }
  }

  ${sanityDocumentFieldsFragment}
  ${evaluationFieldsFragment}
  ${questionFieldsFragment}
  ${scheduledSessionParticipantCorrectionEntryFieldsFragment}
`;